import { ReactEditor } from 'slate-react';
import { type EditorPlugin } from '../../types/aha-editor';
import TableUtils from './TableUtils';
import { Editor, type Node, Transforms } from 'slate';

const TableMouseDownPlugin: EditorPlugin = {
  name: 'Table onMouseDown handler',
  handlers: {
    onMouseDown: (event, ahaEditor) => {
      const { controller, editor } = ahaEditor;
      const { tableSelection } = controller.state.pluginState;
      if (!tableSelection) return false;

      // If the user right clicks on a table with a selection,
      // we should put the cursor in the cell that was clicked on
      // but only if it's not one of the selected cells
      if (
        event?.target &&
        event.button === 2 &&
        tableSelection.multipleCellsSelected
      ) {
        let node: Node | undefined;
        // We could potentially click something that's outside of the editor
        // content and don't want to crash if this happens so wrap in try/catch
        try {
          node = ReactEditor.toSlateNode(editor, event.target as Element);
        } catch (e) {}

        if (!node) return false;

        const path = ReactEditor.findPath(editor, node);
        const tableCell = TableUtils.parentCell(editor, path);

        if (
          tableCell &&
          !tableSelection.isCellSelected(
            tableCell[1].slice(0, -2),
            tableCell[1].slice(-2)
          )
        ) {
          const pointToSelect = Editor.point(editor, tableCell[1]);
          Transforms.select(editor, pointToSelect);
        }
      }

      tableSelection.shouldClearSelection = true;
      return false;
    },
  },
};

export default TableMouseDownPlugin;
